var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"main-title"},[_vm._v("Admin dashboard")])]),_vm._v(" "),_c('b-row',[_c('b-col'),_vm._v(" "),_c('b-col'),_vm._v(" "),_c('b-col')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2610c016","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 1013
// module chunks = 0